module.exports = __webpack_public_path__ + "img/new-calender-icon.dffd54eb.svg";